import { useEffect, useRef } from 'react';
import { useGallery } from 'app/hooks';

export default (applySearchBarConfig, searchBarConfig) => {
  const gallery = useGallery();
  const applyConfigRef = useRef(null);
  const searchBarConfigRef = useRef(searchBarConfig);

  useEffect(() => {
    applyConfigRef.current = (searchParameters) =>
      applySearchBarConfig(searchParameters);
  });

  useEffect(() => {
    searchBarConfigRef.current = searchBarConfig;
  });

  const applyConfigFn = (e) => applyConfigRef.current(e.detail);

  useEffect(() => {
    document.addEventListener('searchbar.updated', applyConfigFn);
    return () =>
      document.removeEventListener('searchbar.updated', applyConfigFn);
  }, []);

  useEffect(() => {
    const event = new CustomEvent('search.updated', {
      detail: searchBarConfigRef.current,
    });
    document.dispatchEvent(event);
    // Only re-dispatch when the gallery's search parameters change — the
    // config value itself is read from a ref (kept fresh above) so it is
    // never a dependency here, otherwise every render would re-fire the
    // event.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gallery.searchParameters]);
};
